export default __webpack_public_path__ + "static/SecondaryBtnStates-2f582bdaf7b8ecabb66d45861f748699.png";